import { render } from "./SkeletonConfirmData.vue?vue&type=template&id=c8cc8b6e&scoped=true"
import script from "./SkeletonConfirmData.vue?vue&type=script&lang=js"
export * from "./SkeletonConfirmData.vue?vue&type=script&lang=js"

import "./SkeletonConfirmData.vue?vue&type=style&index=0&id=c8cc8b6e&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cc8b6e"]])

export default __exports__